import { Customer } from "./Customer";
import { Serializable } from "../utilities/Serializable";

export class CustomerGroup extends Serializable {
    uuid: string;
    name: string;

    owner: Customer;
    customers: Customer[];
    
    notes: string;

    constructor() {
        super();
        this.name = "";
        this.customers = [];
    }

}


// WEBPACK FOOTER //
// ./src/app/models/CustomerGroup.ts